import { events } from '../../api/api'
import queryString from 'query-string'
import { setCategory, setDate, setView } from './setFilters'
import moment from 'moment'

export const FETCH_EVENTS_BEGIN = 'FETCH_EVENTS_BEGIN'
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS'
export const FETCH_EVENTS_ERROR = 'FETCH_EVENTS_ERROR'

export const fetchEvents = () => async dispatch => {
  const queryParams = queryString.parse(window.location.search)
  const { category, date, view } = queryParams

  if (category) {
    dispatch(setCategory(category))
  }

  if (date) {
    dispatch(setDate(moment(date)))
  }

  if (view) {
    dispatch(setView(view))
  } else if (process.env.REACT_APP_COMPONENT_DEFAULT_VIEW) {
    dispatch(setView(process.env.REACT_APP_COMPONENT_DEFAULT_VIEW))
  }

  dispatch({ type: FETCH_EVENTS_BEGIN })

  return events()
    .then(res => {
      if (res) {
        if (res && res.data) {
          dispatch({
            type: FETCH_EVENTS_SUCCESS,
            payload: res.data
          })
        }
      } else {
        dispatch({
          type: FETCH_EVENTS_ERROR,
          payload: 'There was an error retrieving events - please wait a moment, then try again.'
        })
      }
    })
    .catch(err => {
      dispatch({ type: FETCH_EVENTS_ERROR, payload: err })
    })
}
